import { useContext, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { DataGridPro } from "@mui/x-data-grid-pro";
import { getColumns } from "./format-order-columns";
import { MemberContext } from "../../hooks/MemberContext";
import { useAuth } from "../../hooks/useAuth";


const OrderTable = ({ orders }) => {
  const { memberId } = useContext(MemberContext);
  const { userInfo } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // GO-3036: affiliates do not see the PV column on a customer's order list.
  const columns = useMemo(
    () => getColumns(userInfo?.isAffiliate),
    [userInfo?.isAffiliate]
  );

  const searchParams = new URLSearchParams(location.search);
  const drawer = searchParams.get("drawer");

  const handleOrderClick = (row) => {
    const orderHref = row.row.href.split("/").pop();
    navigate(`${location.pathname}?drawer=${drawer}&id=${memberId}&drawerContent=orderDetails&orderHref=${orderHref}`, { state: location });
  }

  return (
    <DataGridPro
      className="order-table-data-grid-drawer"
      id="OrdersDataGrid"
      columns={columns}
      rows={orders}
      getRowId={(row) => row.uniqueId}
      disableColumnMenu
      autoHeight
      hideFooter
      onRowClick={handleOrderClick}
      sx={{
        '.MuiDataGrid-root .MuiDataGrid-cell': {
          overflow: 'visible !important',
          whiteSpace: 'nowrap',
          textOverflow: 'initial',
          zIndex: 1
        },
        '.MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell': {
          overflow: 'visible !important',
          whiteSpace: 'nowrap'
        },
        fontSize: "12px",
        border: "none",
      }}
    />
  );
};

export { OrderTable };
